import _ from 'lodash'
import orm from 'models'
import { createSelector as ormSelector } from 'redux-orm'
import { createSelector } from 'reselect'
import { createFilteredEntitiesSelector } from "selectors/entities";
import getEntities from 'selectors/entities'
import { getKeyWindowSelector } from "selectors/key_windows";

const getAllDossiers = ormSelector (orm, getEntities, (session) => {
  const dossiers = session.dossier.all ().toModelArray ()
                        .filter (dossier => !dossier.isArchived)
                        .map (dossier => {
                          const {ref} = dossier
                          return {
                            ...ref,
                            patient: session.contact.withId (dossier.patientId),
                            responsibles: dossier.responsibleIds && dossier.responsibleIds.map(id => session.employment.withId(id))
                          }
                        })

  return _.sortBy(dossiers, (dossier) => {
    return `${dossier.patient?.firstName || ''} ${dossier.patient?.lastName || ''}`.toLowerCase()
  })
})

export const getDossier = (state, id) => {
  let session = orm.session(state.entities)
  let dossier = session['dossier'].withId(id)
  return {
    ...dossier.ref,
    patient: session.contact.withId(dossier.patientId),
    responsibles: dossier.responsibleIds && dossier.responsibleIds.map(id => session.employment.withId(id))
  }
}

export const getFilteredDossiers = (keywindow) => createFilteredEntitiesSelector(getDossiers(keywindow), 'dossier')

export const getDossiers = (keyWindow) => createSelector([getKeyWindowSelector('dossier', keyWindow, getAllDossiers)], (dossiers) => {
  return _.sortBy(dossiers, (dossier) => {
    return `${dossier.patient?.firstName || ''} ${dossier.patient?.lastName || ''}`.toLowerCase()
  })
})

export const getDossiersOfEmployment = (keyWindow, employmentId) => createSelector([getDossiers(keyWindow)], (dossiers) => {
  return dossiers.filter((dossier) => employmentId && dossier.responsibleIds?.includes(employmentId.toString()))
})
